/**
* AnalyticsEventContent.js
* 
* Created on Dec 1, 2016, 13:06:12 AM
*
* @author Pascal van Beek for Ranj
**/

import Content from "./Content";

export default class AnalyticsEventContent extends Content {
    constructor(languagePack, contentID, label) {
        super(AnalyticsEventContent.NAME, AnalyticsEventContent.TYPE, label, languagePack, contentID);
    }
    /*
    *
    * @param {type} property
    * @returns {unresolved}
    */
    getValueForProperty(property) {
        return this.getLanguagePackText(property);
    }
    /*
    *
    * @param {String} property
    * @param {*} value
    * @returns {undefined}
    */
    setValueForProperty(property, value) {
        if (this.getValueForProperty(property) !== value) {
            this.setLanguagePackText(property, value);
        }
    }
    getEventCategory() {
        return this.getValueForProperty(AnalyticsEventContent.ANALYTICS_EVENT_CATEGORY);
    }
    setEventCategory(value) {
        this.setValueForProperty(AnalyticsEventContent.ANALYTICS_EVENT_CATEGORY, value);
    }
    getEventAction() {
        return this.getValueForProperty(AnalyticsEventContent.ANALYTICS_EVENT_ACTION);
    }
    setEventAction(value) {
        this.setValueForProperty(AnalyticsEventContent.ANALYTICS_EVENT_ACTION, value);
    }
    getEventLabel() {
        return this.getValueForProperty(AnalyticsEventContent.ANALYTICS_EVENT_LABEL);
    }
    setEventLabel(value) {
        this.setValueForProperty(AnalyticsEventContent.ANALYTICS_EVENT_LABEL, value);
    }
    getEventValue() {
        return this.getValueForProperty(AnalyticsEventContent.ANALYTICS_EVENT_VALUE);
    }
    setEventValue(value) {
        this.setValueForProperty(AnalyticsEventContent.ANALYTICS_EVENT_VALUE, value);
    }
    clone(value) {
        const clone = new AnalyticsEventContent(this._languagePack, this.getLabel());
        clone.setEventCategory(this.getEventCategory());
        clone.setEventAction(this.getEventAction());
        clone.setEventLabel(this.getEventLabel());
        clone.setEventValue(this.getEventValue());
        return clone;
    }
    remove() {
        this.setEventCategory(null);
        this.setEventAction(null);
        this.setEventLabel(null);
        this.setEventValue(null);
        super.remove();
    }
    convertToObject() {
        return this.getObject([]);
    }
}

AnalyticsEventContent.NAME = "AnalyticsEvent";
AnalyticsEventContent.TYPE = "engAnalyticsEventContent";

AnalyticsEventContent.ANALYTICS_EVENT_CATEGORY = "eventCategory";
AnalyticsEventContent.ANALYTICS_EVENT_ACTION = "eventAction";
AnalyticsEventContent.ANALYTICS_EVENT_LABEL = "eventLabel";
AnalyticsEventContent.ANALYTICS_EVENT_VALUE = "eventValue";